import { render, staticRenderFns } from "./PlateInput.vue?vue&type=template&id=78f07382&scoped=true&"
import script from "./PlateInput.vue?vue&type=script&lang=js&"
export * from "./PlateInput.vue?vue&type=script&lang=js&"
import style0 from "./PlateInput.vue?vue&type=style&index=0&id=78f07382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f07382",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VHover,VIcon,VList,VListItem,VListItemGroup,VListItemTitle,VMenu,VRow})
